import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "filter",
    standalone: false
})
export class FilterPipe implements PipeTransform {
  transform(arr: any[], filter: any): any[] {
    return arr.filter((item) => {
      for (const key in filter) {
        if (item[key] !== filter[key]) {
          return false;
        }
      }
      return true;
    });
  }
}
